import { FC, useState } from 'react';
import { capitalize } from 'lodash';

import CommonButton from 'components/CommonButton/CommonButton';
import { PractitionerWeeklyTimeSlot } from 'pages/PractitionerPage/MainSection/PractitionerHours/PractitionerSchedule/PractitionerSchedule';

interface CopyPanelProps {
  day: string;
  onCopy: (timeSlots: PractitionerWeeklyTimeSlot[]) => void;
  timeSlots: PractitionerWeeklyTimeSlot[];
  onClose: (
    focusableElement?:
      | HTMLElement
      | React.MutableRefObject<HTMLElement | null>
      | undefined
  ) => void;
}

const CopyPanel: FC<CopyPanelProps> = ({ day, onCopy, timeSlots, onClose }) => {
  const [checkedTimeSlots, setCheckedTimeSlots] = useState(() =>
    timeSlots.map(({ day: timeSlotDay, start, end }) => ({
      day: timeSlotDay,
      disabled: timeSlotDay === day || (!start && !end),
      checked: timeSlotDay === day || (!start && !end),
    }))
  );

  const handleCheckedTimeSlots = (day: string, isChecked: boolean) => {
    const updatedCheckedTimeSlots = [...checkedTimeSlots].map((timeSlot) => {
      const { day: timeSlotDay } = timeSlot;
      if (timeSlotDay === day) {
        timeSlot.checked = isChecked;
      }
      return timeSlot;
    });
    setCheckedTimeSlots(updatedCheckedTimeSlots);
  };

  const handleClickApply = () => {
    const checkedOptions = checkedTimeSlots.filter(
      ({ checked, disabled }) => checked && !disabled
    );

    const updatedOperatory = timeSlots.find(
      (timeSlot) => timeSlot.day === day
    )!;

    const copyTimeSlots = timeSlots.map((timeSlot) => {
      const updatedTimeSlot = checkedOptions.find(
        (option) => option.day === timeSlot.day
      );
      return updatedTimeSlot
        ? { ...timeSlot, operatories: updatedOperatory.operatories }
        : { ...timeSlot };
    });
    onCopy(copyTimeSlots);
    onClose();
  };

  return (
    <div className="flex flex-col justify-between gap-y-1.6 pt-1.6 pb-1.8 px-2">
      <h3>Copy operatory to</h3>
      {checkedTimeSlots.map(({ day, checked, disabled }) => (
        <div className="flex justify-between" key={day}>
          <label htmlFor={`option-${day}`}>{capitalize(day)}</label>
          <input
            id={`option-${day}`}
            type="checkbox"
            className="w-1.8 h-1.8"
            checked={checked}
            disabled={disabled}
            onChange={(e) => handleCheckedTimeSlots(day, e.target.checked)}
          />
        </div>
      ))}
      <CommonButton
        className="!min-w-[11rem]"
        onClick={() => {
          handleClickApply();
        }}
      >
        Apply
      </CommonButton>
    </div>
  );
};

export default CopyPanel;
